import { render } from "./MarketsAnalytics.vue?vue&type=template&id=4b253d0c&scoped=true"
import script from "./MarketsAnalytics.vue?vue&type=script&lang=js"
export * from "./MarketsAnalytics.vue?vue&type=script&lang=js"

import "./MarketsAnalytics.vue?vue&type=style&index=0&id=4b253d0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b253d0c"]])

export default __exports__